<div class="flex flex-col gap-6">
  <span class="text-xl font-bold">Datos identificativos</span>

  <div class="grid grid-cols-2 gap-4">
    <div class="flex gap-3 items-start">
      <div class="flex flex-col">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Nombre del proyecto</span>
        </div>
        <span class="text-[16px] font-normal">{{ project?.projectName || '-' }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <div class="flex flex-col">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Nombre y apellidos del responsable</span>
        </div>
        <span class="text-[16px] font-normal">
          {{ project?.userNameResponsible || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('contactEmailResponsible')"
        (change)="reviewFields.toggleField('contactEmailResponsible')" />

      <div class="flex flex-col">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Correo electrónico de contacto del responsable</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('contactEmailResponsible')"
            class="-mt-2"
            [description]="previousReviewText('contactEmailResponsible')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-normal">
          {{ project?.contactEmailResponsible || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <div class="flex flex-col">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Departamento responsable</span>
        </div>
        <span class="text-[16px] font-normal">
          {{ project?.department || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <div class="flex flex-col">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Nombre dirección general, SGT u organismo público responsable</span>
        </div>
        <span class="text-[16px] font-normal">
          {{ project?.selectedOrgCode || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <div class="flex flex-col">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Nombre del servicio o unidad administrativa responsable</span>
        </div>
        <span class="text-[16px] font-normal">
          {{ project?.serviceName || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
